// handleDownloadFullData.js
import { getComparisonRows } from './getComparisonRows';
import { getBeaconStatus } from './getBeaconStatus';

export function handleDownloadFullData(sortedApiReturn, includeNonValidated, regressionTag) {
  let csvContent = '';

  if (regressionTag && regressionTag.trim() !== '') {
    csvContent += `Regression Tag:,${regressionTag}\n`;
  } else {
    csvContent += `Regression Tag:,N/A\n`;
  }
  csvContent += '\n';

  // Get selected device information
  const selectedDevice = JSON.parse(localStorage.getItem('selectedDevice') || '{}');
  const deviceName = selectedDevice.name || 'No Device';
  const deviceId = selectedDevice.id || 'N/A';

  const exportList = includeNonValidated
    ? sortedApiReturn
    : sortedApiReturn.filter((b) => b.truth.status !== 404 && b.beaconData.status !== 404);

  exportList.forEach((beacon) => {
    // Remember whether this beacon was originally "not validated"
    const wasNotValidated = beacon.truth.status === 404 || beacon.beaconData.status === 404;
    // 1. Determine overall status, honoring any manual override
    const statusLabelMap = {
      PASS: 'Pass',
      FAIL: 'Fail',
      MISSING: 'Missing Event',
      NOT_VALIDATED: 'Not Validated',
      NOT_PRESENT_IN_APP: 'Not Present In App',
    };

    const overallStatus = statusLabelMap[getBeaconStatus(beacon)] || getBeaconStatus(beacon);

    const devicePart =
      deviceId !== 'N/A' ? `Device Name: ${deviceName}, Device ID: ${deviceId}, ` : '';

    // 2. Meta line
    const eventNamePart = beacon.eventName ? `Event: ${beacon.eventName}, ` : '';
    const metaLine = `Beacon ${beacon.beaconID}, ${eventNamePart}${beacon.beaconType}, ${new Date(
      beacon.timestamp,
    ).toLocaleString('en-US', {
      timeZoneName: 'short',
    })}, ${overallStatus},  ${devicePart} `;
    csvContent += metaLine + '\n';

    // 3. Insert notes if any
    if (beacon.notes && beacon.notes.trim() !== '') {
      csvContent += `Notes: ${beacon.notes}\n`;
    }

    // 4. Table format: based on original validation state, NOT on current overallStatus
    if (wasNotValidated) {
      // Only two columns: Variable Name, Value (from real beacon)
      csvContent += 'Variable Name,Value\n';
      Object.entries(beacon.beaconData.data)
        .filter(([key]) => key !== 'market')
        .forEach(([key, val]) => {
          const actual = val instanceof Object ? val.value : val;
          csvContent += `"${key}","${actual}"\n`;
        });
    } else {
      // Normal comparison table
      csvContent += 'Variable Name,Expected Value,Actual Value,Status,Type\n';

      // Pull in modifiedRows so that manual toggles apply
      const rows = getComparisonRows(beacon.truth, beacon.beaconData, beacon.modifiedRows || {});

      // optional: sort custom attributes first
      rows.sort((a, b) => {
        const aPr = a.variableName.includes('data.custom_attributes') ? 0 : 1;
        const bPr = b.variableName.includes('data.custom_attributes') ? 0 : 1;
        return aPr - bPr;
      });

      rows.forEach((row) => {
        csvContent += `"${row.variableName}","${row.expectedValue}","${row.actualValue}","${row.passFail}","${row.fieldType}"\n`;
      });
    }

    csvContent += '\n'; // blank line between beacons
  });

  // Trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'full_beacon_data.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
